export default __webpack_public_path__ + "static/media/unsubscribed-colored.b8665deb.svg";